"use client";

import { type HTMLMotionProps, motion } from "motion/react";
import { type ReactNode } from "react";

export interface ModalContentAnimationProps extends HTMLMotionProps<"div"> {
  children: ReactNode;
  className?: string;
  exitDelay?: number;
}

export const ModalContentAnimation: React.FC<ModalContentAnimationProps> = ({
  children,
  className,
  exitDelay = 0,
  ...props
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: { duration: 0.3, ease: "easeOut" },
      }}
      exit={{
        opacity: 0,
        transition: { duration: 0.3, delay: exitDelay, ease: "easeIn" },
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
